<template>
  <div class="project_list_i cursor_pointer d_flex bc_fff">

    <div class="picture_w" :style="randomRgb">
      <el-image
        class="main_cover"
        :src="
          data.cover
            ? data.cover + '!283'
            : require('@/assets/images/QaKkPnoKQkBK7pdG.jpeg')
        "
        alt=""
        lazy
      />

      <!-- 状态值 -->
      <img class="state_desc" :src="data.state===4? require('@/assets/images/p_item_3.png') : require('@/assets/images/p_item_4.png')" alt="">
    </div>

    <div class="detail_w flex_1">
      <div class="top">
        <div class="title text_ellipsis fz22 c_1A1A1A">{{ data.title }}</div>
        <div class="data d_flex align_item_c justify_content_sb">
          <div class="">
            <span class="fz18">{{ data.state===4?'成交价':'价格' }}：</span>
            <span class="price font_w_bold fz20 c_CF3342">
              {{ numTurnText(data.currentPrice) }}元
            </span>
            <span class="fz12 c_CF3342">{{ data.priceUnitDesc }} <span v-if="data.priceUnit==='zongjia'">({{ priceUnitKey[data.priceUnit] }})</span></span>
          </div>
          <div class="d_flex  fz14 c333">
            <span class="d_flex"><img src="@/assets/images/project_hall_2.png" alt=""> <span style="margin:0 0 0 5px">{{ data.statis.applyCnt || 0 }}人报名</span></span>

            <span
              class="d_flex"
              style="margin: 0 0 0 20px"
            ><img src="@/assets/images/project_hall_1.png" alt=""> <span style="margin:0 0 0 5px">{{ data.statis.onlookerCnt || 0 }}次围观</span>
            </span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="desc fz14 d_flex justify_content_sb">
          <div style="width: 100%">
            <div>
              <span class="c_808080">项目编号：</span>
              <span class="c333">{{ data.projectNo }}</span>
            </div>
            <div class="item_c">
              <span class="c_808080">资金性质：</span>
              <span class="c333">{{ capitalPropertyKey[data.capitalProperty] }}</span>
            </div>
            <div>
              <span class="c_808080">招标类型：</span>
              <span class="c333">{{ biddingTypeKey[data.biddingType] }}</span>
            </div>
          </div>

          <div style="width: 100%">
            <div>
              <span class="c_808080">发布时间：</span>
              <span class="c333">{{ data.onlineAt }}</span>
            </div>
            <div class="item_c">
              <span class="c_808080">项目周期：</span>
              <span class="c333">{{ data.deadline }} {{ deadlineUnitKey[data.deadlineUnit] }}</span>
            </div>
            <div>
              <span class="c_808080">付款方式：</span>
              <span class="c333">{{ paymentModeKey[data.paymentMode] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { numTurnText } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      randomRgb: {
        backgroundColor:
            'rgb(' +
            Math.floor(Math.random() * 130 + 110) +
            ',' +
            Math.floor(Math.random() * 130 + 110) +
            ',' +
            Math.floor(Math.random() * 130 + 110) +
            ')'
      }
    }
  },
  computed: {
    ...mapGetters(['paymentModeKey', 'priceUnitKey', 'deadlineUnitKey', 'capitalPropertyKey', 'biddingTypeKey']),

    // 格式化金额（中文）
    numTurnText: function() {
      return function(num) {
        return numTurnText(num)
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
  .project_list_i {
    padding: 20px;
    width: 100%;
    border: 1px solid #e6e6e6;
    margin: 0 0 10px 0;
  }

  .picture_w{
    position: relative;
      width: 388px;
      height: 232px;
      .state_desc{
        position: absolute;
        top: 10px;
        right: 10px;
        width: 68px;
        height: 68px;
      }
  }
  .main_cover {
    ::v-deep img {
      position: static; // 兼容ie
      display: block;
      width: 388px;
      height: 232px;
      transform: none; // 兼容ie
    }
  }
  .detail_w {
    margin: 0 0 0 20px;
    .top {
      border-bottom: 1px solid #e6e6e6;
      .title{
        width: 750px;
      }
      .data {
        margin: 20px 0;
      }
    }
    .bottom {
      margin: 30px 0 0 0;
    }
    .item_c {
      margin: 30px 0;
    }
  }
  </style>
